import type { RouteObject } from "react-router";
import { OrderList } from "./order-list/OrderList";
import { detailStackRoute } from "@/features/detail/detail.routes";
import { ORDER_LIST_SEGMENT, ORDER_SEGMENT } from "./order.paths";
import { orderSnapshotRoute } from "./order-snapshot/orderSnapshot.routes";

/** The order feature's routes: the list (with the detail stack over it) and the snapshots page. */
export const orderRoute: RouteObject = {
  path: ORDER_SEGMENT,
  children: [
    {
      path: ORDER_LIST_SEGMENT,
      element: <OrderList />,
      children: [detailStackRoute],
    },
    orderSnapshotRoute,
  ],
};
